import React from 'react';
import { GetServerSideProps, NextPage } from 'next/types';
import { defaultInternationalization, defaultLanguage } from 'corporate-types';
import { internationalizationToLanguages } from 'corporate-utils';

import { WarningOutlinedIcon } from '../../assets';
import {
  CardList,
  CardListItem,
  CardMessage,
} from '../../components/cards/card-error/CardError.style';
import CardError from '../../components/cards/card-error/CardError';
import { getAllTranslations } from '../../utils/localize';
import { ImageWrapper } from '../../styles/shared';
import { DEFAULT_IMAGE } from '../../models/domain/const';
import ImageWithFallback from '../../components/image-with-fallback/ImageWithFallback';
import { getLogo } from '../../utils/media';
import { getCompany } from '../../utils/company';
import { Companies } from '../../models/domain/enum';

const Custom502: NextPage<{
  translations: any;
  isPrerenderRequest: boolean;
}> = ({ translations, isPrerenderRequest }) => {
  const { title, message, actionText, listItems } =
    translations?.pages?.errors?.internal ?? {};
  const company = getCompany();

  return (
    <>
      <ImageWrapper>
        <ImageWithFallback
          src={getLogo(company)}
          width={
            company === Companies.SIRMAN
              ? '197px'
              : company === Companies.FELSINEA
                ? '233px'
                : '197px'
          }
          height="74px"
          alt="error_logo"
          fallbackSrc={DEFAULT_IMAGE}
          isPrerenderRequest={isPrerenderRequest}
        />
      </ImageWrapper>
      <CardError
        icon={WarningOutlinedIcon}
        title={title ?? ''}
        actionText={actionText ?? ''}
      >
        <>
          <CardMessage>{message ?? ''}</CardMessage>
          <CardList>
            {React.Children.toArray(
              listItems?.map((text: string) => (
                <CardListItem>{text ?? ''}</CardListItem>
              ))
            )}
          </CardList>
        </>
      </CardError>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  resolvedUrl,
}) => {
  const allTranslations = await getAllTranslations();
  const translations =
    allTranslations[
      internationalizationToLanguages(
        locale || defaultInternationalization,
        resolvedUrl
      ) || defaultLanguage
    ];

  return {
    props: {
      translations,
    },
  };
};

export default Custom502;
